<template>
  <div id="contenedor-programacion-main">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'ProgramacionMain',
  data() {
    return {};
  },

};
</script>

<style lang="scss">

</style>
